import type { Dictionary } from '@noths/polaris-dev-ts-recipes';
import type { AnyAction, Reducer } from '@reduxjs/toolkit';
import * as R from 'ramda';

const HYDRATE_STATE = 'HYDRATE_STATE';

export const withStateHydration =
  <S extends Dictionary>(reducer: Reducer) =>
  (state: S, action: AnyAction) => {
    switch (action.type) {
      case HYDRATE_STATE:
        return R.mergeDeepRight(state, action.payload);

      default:
        return reducer(state, action);
    }
  };

export const hydrateState = <S>(state: S) => ({
  type: HYDRATE_STATE,
  payload: state,
});
